var r;!function(r){r.success="Success",r.error="Error",r.warning="Warning",r.info="Info"}(r||(r={}));export{r as LabelText};
//# sourceMappingURL=message.types.js.map
